<div class="container-fluid-modal">
    <div class="ModalHeader">
        <h4 mat-dialog-title>Products</h4>
        <div class="headerButton">
            <button type="button" class="btn btn-success" (click)="sendSelected(selectedIndex)"><i
                    class="fa fa-floppy-o" aria-hidden="true"></i> Ok
            </button>
            <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i class="fa fa-times"
                    aria-hidden="true"></i> Cancel
            </button>
        </div>
    </div>

    <mat-dialog-content>
        <div class="card">
            <div class="card-body">
                <form class=" required">
                    <div class="row">
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <th scope="col" class="col-xs-2">S.No</th>
                                    <th scope="col">Code</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Qty</th>
                                    <th scope="col">Rate</th>
                                    <th scope="col">Discount</th>
                                    <th scope="col">Amount</th>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let product of productData |paginate: { id: 'dashboardModal_pagination', itemsPerPage: per_page, currentPage: page, totalItems: total_count};  let i = index"
                                        [ngClass]="{'sel': i === selectedIndex }" (click)="selectRow(i)"
                                        (dblclick)="sendSelected(selectedIndex)">
                                        <th scope="row">{{product.id}}</th>
                                        <td>{{product.code}}</td>
                                        <td>{{product.name}}</td>
                                        <td>{{product.quantity}}</td>
                                        <td>{{product.rate}}</td>
                                        <td>{{product.discount}}</td>
                                        <td>{{product.amount}}</td>
                                    </tr>
                                </tbody>

                            </table>

                        </div>
                    </div>

                </form>
            </div>

            <div class="footerWrapper row">
                <div class="searchWrapper col-lg-7 col-md-8">
                    <div class="input-group">
                        <select name="searchBy" [(ngModel)]="searchBy" data-show-content="true" class="col-lg-4 col-md-2 border" (change)="getSearchValue()">

                        <option name="codeNo" value="0"> Search by Name</option>
                        <option name="codeNoName" value="1"> Search by Code</option>

                        </select>
                        <div>
                            <span class="input-group-prepend">
                                <input type="text" placeholder="Search" class="form-control" name="searchTxt" [(ngModel)]="searchTxt" [placeholder]="placeHolder">

                                <span class="input-group-text" (click)="doSearch()">
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                </span>
                                <span class="input-group-text" (click)="doRefresh()">
                                    <i class="fa fa-refresh" aria-hidden="true"></i>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="paginationWrapper col-lg-3 col-md-4">
                    <pagination-template id="dashboardModal_pagination" #p="paginationApi"
                        (pageChange)=doPaginate($event)>
                        <div class="pageheader">
                            <div class="firstIndex">
                                <a *ngIf="!p.isFirstPage()" (click)="p.setCurrent(1)">
                                    << </a> </div> <div class="pagination-previous">
                                        <a *ngIf="!p.isFirstPage()" (click)="p.previous()">
                                            < </a> </div> <div *ngFor="let page of p.pages"
                                                [class.current]="p.getCurrent() === page.value">
                                                <a (click)="p.setCurrent(page.value)"
                                                    *ngIf="p.getCurrent() !== page.value">
                                                    <span>{{ page.label }}</span>
                                                </a>
                                                <div *ngIf="p.getCurrent() === page.value">
                                                    <span>{{ page.label }}</span>

                                                </div>
                            </div>

                            <div class="pagination-next" [class.disabled]="p.isLastPage()">
                                <a *ngIf="!p.isLastPage()" (click)="p.next()"> > </a>
                            </div>
                            <div class="lastPageIndex">
                                <a *ngIf="!p.isLastPage()" (click)="p.setCurrent(p.getLastPage())"> >> </a>
                            </div>
                        </div>

                    </pagination-template>
                </div>
            </div>


        </div>

    </mat-dialog-content>
</div>
